import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/home';
import Deals from './pages/deals';
import Download from './pages/download';
import Contact from './pages/contact';
import AboutUs from './pages/aboutus';
import { ShoppingListProvider } from './deals/shoppinglistcontext';
import { SubscriptionProvider } from './subscription/subscriptioncontext';
import ShoppingList from './pages/shoppinglist';
import Footer from './utils/footer';
import Dashboard from './pages/dashboard';
import Login from './dashboard/login';
import Signup from './dashboard/signup';
import ForgotPassword from './dashboard/forgotpassword';
import ResetPassword from './dashboard/resetpassword';
import Price from './dashboard/price';
import Subscription from './subscription/subscription';
import Navbar from './utils/navbar';
import PrivacyPolicy from './pages/privacypolicy';
import TermsConditions from './pages/termsconditions';
import CampaignsPage from './pages/campaigns';
import StoreDeals from './deals/store-deals';

// Layout component that conditionally renders Navbar and Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';
  
  return (
    <>
      {!isDashboard && <Navbar />}
      <div>
        {children}
      </div>
      {!isDashboard && <Footer />}
    </>
  );
};

// Protected route component
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  const [, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedIn);
  }, []);

  return (
    <SubscriptionProvider>
      <ShoppingListProvider>  
        <Router>
        <Routes>
          <Route path="/" element={
            <Layout>
              <Home />
            </Layout>
          } />
          
          <Route path="/login" element={
            <Layout>
              <Login onLoginSuccess={() => setIsLoggedIn(true)} />
            </Layout>
          } />
          
          <Route path="/signup" element={
            <Layout>
              <Signup />
            </Layout>
          } />
          
          <Route path="/forgot-password" element={
            <Layout>
              <ForgotPassword />
            </Layout>
          } />
          
          <Route path="/reset-password/:uidb64/:token" element={
            <Layout>
              <ResetPassword />
            </Layout>
          } />
          
          <Route path="/price" element={
            <Layout>
              <Price />
            </Layout>
          } />
          
          <Route path="/subscription" element={
            <Layout>
              <Subscription />
            </Layout>
          } />
          
          <Route path="/aboutus" element={
            <Layout>
              <AboutUs />
            </Layout>
          } />
          
          <Route path="/contact" element={
            <Layout>
              <Contact />
            </Layout>
          } />
          
          {/* Dashboard route without Navbar and Footer */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/deals" element={
            <Layout>
              <Deals />
            </Layout>
          } />
          
          <Route path="/store-deals" element={
            <Layout>
              <StoreDeals />
            </Layout>
          } />
        
          <Route path='/download' element={
            <Layout>
              <Download />
            </Layout>
          } />

          <Route path='/privacypolicy' element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          } />

          <Route path='/termsconditions' element={
            <Layout>
              <TermsConditions />
            </Layout>
          } />
          
          <Route path='/shopping-list' element={
            <Layout>
              <ShoppingList />
            </Layout>
          } />
          
        <Route path='/campaigns' element={
          <Layout>
            <CampaignsPage />
          </Layout>
        } />
        
        </Routes>
        </Router>      
      </ShoppingListProvider>
    </SubscriptionProvider>
  );
}

export default App;
